module.exports = require('./helpers/bundle-url').getBundleURL('1UzNj') + "logo.c51670a8.svg";